// TODO: Add unit test check for message events
export default function executeInWindow(url) {
    const logoutPromise = Promise.resolve(url);

    const newWindowInstance = window.open(
        '',
        '',
        'top=1,left=1,width=1,height=1',
    );

    return logoutPromise.then((res) => {
        if (
            res.status !== 200 ||
            !res.data ||
            !res.data.data ||
            !res.data.data.attributes
        ) {
            return Promise.reject(new Error('Invalid JSON response'));
        }

        if (newWindowInstance && !newWindowInstance.closed) {
            newWindowInstance.location.href = res.data.data.attributes.bookmaker_url;
        }

        return {
            data: {
                data: {
                    attributes: {
                        success: true,
                    },
                },
            },
            status: 200,
        };
    })
    .catch((e) => {
        console.error(e);
        return ({
            data: {
                data: {
                    attributes: {
                        success: true,
                    },
                },
            },
            status: 200
        });
    });
}



// WEBPACK FOOTER //
// /src/js/common/utils/executeInWindow.js